export default __webpack_public_path__ + "static/inspiration-a675eceed40d35f28fad9a0251e52b05.jpg";